import { useParams } from "react-router-dom"
import Footer from "../components/common/Footer"
import HeaderLogo from "../components/headers/HeaderLogo"
import { useEffect, useState } from "react"
import { getShopById, getShopPricingList } from "../api/shopsApi"
import { GetShopByIdResultDto } from "../models/api/shopApiTypes"
import ShopDetails from "../components/shop/ShopDetails"
import "../assets/css/shopdetails.css"

export default function ShopPage() {
  const { shopSlug } = useParams()
  const [shop, setShop] = useState<GetShopByIdResultDto>()
  const [hasPricingList, setHasPricingList] = useState(false)

  useEffect(() => {
    if (shopSlug !== undefined)
      getShopById(shopSlug)
        .then((result) => {
          setShop(result)
        })
        .catch(() => console.log("Error loading shop"))
  }, [shopSlug])

  useEffect(() => {
    setHasPricingList(false)
    // The API returns 404 when the shop has no pricing list
    if (shopSlug !== undefined)
      getShopPricingList(shopSlug)
        .then((result) => setHasPricingList(result.pricingLists.some((p) => p.isActive)))
        .catch(() => setHasPricingList(false))
  }, [shopSlug])

  return (
    <>
      <HeaderLogo />
      {shop !== undefined ? <ShopDetails shop={shop} hasPricingList={hasPricingList} /> : null}
      <Footer />
    </>
  )
}
